import React from 'react';
import { Sort } from '@components/Sort';
import { useMediaQuery } from '@context/mediaQuery';
import { ParamsStore } from '@context/params';
import { SortOrder } from '@graphql/reactQuery';
import {
  getCollectorsSortType,
  getDefaultSortTypes,
  getDisplayValueFromSortType,
  getPlaylistsSortType,
} from './constants';
import { clearSortParams, isArtistsBackedSort, isVolumeSort } from './helpers';

export const SoundsSort = () => {
  const { tablet } = useMediaQuery();
  const sortTypes = getDefaultSortTypes({ isTablet: tablet });
  const value = getDisplayValueFromSortType({ isTablet: tablet });

  return (
    <div className="w-[110px] md:w-[204px]">
      <Sort
        value={value}
        sortTypes={sortTypes}
        parseValue={null}
        disabled={false}
        showIcon
        onValueChange={sortType => {
          clearSortParams();

          if (isVolumeSort({ sortType })) {
            return (ParamsStore.total_volume = SortOrder.Desc);
          }

          if (sortType === 'Newest') {
            return (ParamsStore.mint_start_time = SortOrder.Desc);
          }

          if (sortType === 'Oldest') {
            return (ParamsStore.mint_start_time = SortOrder.Asc);
          }

          return (ParamsStore.total_minted = SortOrder.Desc);
        }}
      />
    </div>
  );
};

export const ArtistsSort = () => {
  const { tablet } = useMediaQuery();
  const value = getDisplayValueFromSortType({ isTablet: tablet });
  const sortTypes = getDefaultSortTypes({ isTablet: tablet });

  return (
    <div className="w-[110px] md:w-[204px]">
      <Sort
        value={value}
        sortTypes={sortTypes}
        parseValue={null}
        disabled={false}
        showIcon
        onValueChange={sortType => {
          clearSortParams();

          if (isVolumeSort({ sortType })) {
            return (ParamsStore.total_volume = SortOrder.Desc);
          }

          if (sortType === 'Newest') {
            return (ParamsStore.created_at = SortOrder.Desc);
          }

          if (sortType === 'Oldest') {
            return (ParamsStore.created_at = SortOrder.Asc);
          }

          return (ParamsStore.total_minted = SortOrder.Desc);
        }}
      />
    </div>
  );
};

export const CollectorsSort = () => {
  const { tablet } = useMediaQuery();
  const value = getDisplayValueFromSortType({ isTablet: tablet });
  const sortTypes = getCollectorsSortType({ isTablet: tablet });

  return (
    <div className="w-[158px] md:w-[255px]">
      <Sort
        value={value}
        sortTypes={sortTypes}
        parseValue={null}
        disabled={false}
        showIcon
        onValueChange={sortType => {
          clearSortParams();

          if (isArtistsBackedSort({ sortType })) {
            return (ParamsStore.artists_backed = SortOrder.Desc);
          }

          if (isVolumeSort({ sortType })) {
            return (ParamsStore.total_volume = SortOrder.Desc);
          }

          if (sortType === 'Newest') {
            return (ParamsStore.created_at = SortOrder.Desc);
          }

          if (sortType === 'Oldest') {
            return (ParamsStore.created_at = SortOrder.Asc);
          }

          return (ParamsStore.total_minted = SortOrder.Desc);
        }}
      />
    </div>
  );
};

export const PlaylistsSort = () => {
  const { tablet } = useMediaQuery();
  const value = getDisplayValueFromSortType({ isTablet: tablet });
  const sortTypes = getPlaylistsSortType({ isTablet: tablet });

  return (
    <div className="w-[140px] md:w-[240px]">
      <Sort
        value={value}
        sortTypes={sortTypes}
        parseValue={null}
        disabled={false}
        showIcon
        onValueChange={sortType => {
          clearSortParams();

          if (sortType === 'Newest') {
            return (ParamsStore.created_at = SortOrder.Desc);
          }

          if (sortType === 'Oldest') {
            return (ParamsStore.created_at = SortOrder.Asc);
          }

          return (ParamsStore.num_referral_purchases = SortOrder.Desc);
        }}
      />
    </div>
  );
};
